import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';


const ThemeContext =
  createContext('wood');

const SetThemeContext =
  createContext(() => {});


export const useTheme = () =>
  useContext(ThemeContext);

export const useSetTheme = () =>
  useContext(SetThemeContext);


export const JINGMU_THEMES = [
  'wood',
  'minimal',
  'cyber',
  'mono',
  'club',
];


const META_COLORS = {
  wood: '#fffaf3',
  minimal: '#f7faff',
  cyber: '#05060a',
  mono: '#ffffff',
  club: '#000000',
};


function readTheme() {

  try {

    const value =
      localStorage.getItem(
        'jingmu-v12-theme'
      );

    if (
      JINGMU_THEMES.includes(value)
    ) {
      return value;
    }

  } catch (_) {}

  return 'wood';
}


export const ThemeProvider = ({
  children
}) => {

  const [theme, setThemeState] =
    useState(readTheme);


  const setTheme =
    useCallback((value) => {

      if (
        !JINGMU_THEMES.includes(value)
      ) {
        return;
      }

      setThemeState(value);

      try {

        localStorage.setItem(
          'jingmu-v12-theme',
          value
        );

      } catch (_) {}

    }, []);


  useEffect(() => {

    const root =
      document.documentElement;

    const body =
      document.body;

    root.dataset.theme =
      theme;


    /*
      Semi UI 底层仍然使用 light / dark。

      wood
      minimal
      mono

      -> light

      cyber
      club

      -> dark
    */

    const dark =
      theme === 'cyber' ||
      theme === 'club';


    if (dark) {

      body.setAttribute(
        'theme-mode',
        'dark'
      );

      root.style.colorScheme =
        'dark';

    } else {

      body.removeAttribute(
        'theme-mode'
      );

      root.style.colorScheme =
        'light';

    }


    const meta =
      document.querySelector(
        'meta[name="theme-color"]'
      );

    if (meta) {

      meta.setAttribute(
        'content',
        META_COLORS[theme]
      );

    }

  }, [theme]);


  useEffect(() => {

    function syncTheme(e) {

      if (
        e.key ===
        'jingmu-v12-theme'
      ) {

        setThemeState(
          readTheme()
        );

      }

    }

    window.addEventListener(
      'storage',
      syncTheme
    );

    return () =>
      window.removeEventListener(
        'storage',
        syncTheme
      );

  }, []);


  return (

    <SetThemeContext.Provider
      value={setTheme}
    >

      <ThemeContext.Provider
        value={theme}
      >

        {children}

      </ThemeContext.Provider>

    </SetThemeContext.Provider>

  );
};
